export default "__VITE_ASSET__D_xxiHE7__"